import { BaseThemedCssFunction, css } from "styled-components"
import { screenSizes } from "./grid"

interface MediaSize {
  phone: BaseThemedCssFunction<any>
  tablet: BaseThemedCssFunction<any>
  desktop: BaseThemedCssFunction<any>
  largeLaptop: BaseThemedCssFunction<any>
  largeDesktop: BaseThemedCssFunction<any>
}

const media = Object.keys(screenSizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${screenSizes[label] / 16}em) {
      ${css({}, ...args)}
    }
  `

  return acc
}, {}) as MediaSize

export default media
